import React from "react";

import "./styles.css";

const Skeleton = () => {
  return <div className="Skeleton" />;
};

export { Skeleton };
